import { Grid, Link, Stack, Text } from "basis";
import { SvgInline } from "../SvgInline/SvgInline";

function BpayError() {
  return (
    <Grid rowsGap="6" rowsGap-sm="8">
      <Stack gap="8">
        <SvgInline name="error-dog" width="236" />
        <Text textStyle="heading5" textStyle-sm="heading4">
          Oops, something went wrong
        </Text>
        <Text>
          We've encountered an unexpected problem and are experiencing
          difficulties in processing your request. Please try again later or
          contact Latitude if the problem persists.
        </Text>
        <Link
          appearance="primary-button"
          width="216"
          href="/contact"
          newTab={false}
        >
          Contact Latitude
        </Link>
      </Stack>
    </Grid>
  );
}

export { BpayError };
